import Button from '@berlitz/button'
import { PanelBox, Title } from '@components/Collapse/style'
import { ButtonCol, NextLvlCol, Wrapper } from '@components/NextLevelHeaderCard/style'
import Select from '@components/Select'
import { Col, Grid, Row } from 'react-styled-flexboxgrid'
import styled, { css } from 'styled-components'
export const Header = styled(Row)`
  margin: 0;
  justify-content: space-between;
  align-items: center;
  h1 {
    margin-bottom: ${({ theme }) => theme.space.xs};
  }
  ${Col} {
    padding: 0;
  }
`
export const Selections = styled(Row)`
  margin: 0;
  align-items: flex-end;
  ${Col} {
    padding: 0;
  }
  button {
    padding-top: ${({ theme }) => theme.space.xs};
    padding-bottom: ${({ theme }) => theme.space.xs};
    svg {
      margin-right: ${({ theme }) => theme.space.xs};
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      width: initial;
      float: right;
      margin-top: ${({ theme }) => theme.space.sm};
      margin-bottom: ${({ theme }) => theme.space.sm};
    }
  }
`
export const SelectLevel = styled.div`
  margin-right: ${({ theme }) => theme.space.sm};
`
export const SelectLanguage = styled.div`
  margin-right: ${({ theme }) => theme.space.sm};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-right: 0;
  }
`
export const StyledSelect = styled(Select)`
  width: 100%;
`
export const SubHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.textLinkVisited};
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};
  margin-bottom: ${({ theme }) => theme.space.md};
  color: ${({ theme }) => theme.colors.text03};
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    height: max-content;
    span {
      padding-bottom: ${({ theme }) => theme.space.xs};
    }
    p {
      font-size: ${({ theme }) => theme.fontSize.lg};
      font-weight: ${({ theme }) => theme.fontWeight.bold};
    }
  }
  button {
    padding-top: ${({ theme }) => theme.space.xs};
    padding-bottom: ${({ theme }) => theme.space.xs};
    background-color: ${({ theme }) => theme.colors.brandPrimaryContrast};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.colors.text00};
    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      margin-top: ${({ theme }) => theme.space.sm};
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: end;
  }
`
export const TileRow = styled.div`
  display: flex;
  scroll-behavior: smooth;
  overflow-x: scroll;
  padding: ${({ theme }) => theme.space.lg};
  height: 500px;
`
export const TileCol = styled.div`
  width: 255px;
  z-index: 999;
  padding-right: ${({ theme }) => theme.space.lg};
  position: relative;
  transition: top ease 0.5s;
  top: 0;
  &:hover {
    top: ${({ theme }) => `-${theme.space.sm}`};
  }
`
export const OverrideLPEndOfModuleCard = styled.div`
  > div {
    height: 386px;
  }
`
export const LangBadge = styled.span`
  min-width: ${({ theme }) => theme.layout.lg};
  margin-left: ${({ theme }) => theme.space.sm};
  color: ${({ theme }) => theme.colors.brandSupporting01};
  background-color: ${({ theme }) => theme.colors.brandPrimaryContrast};
  border-radius: ${({ theme }) => theme.radius.xl};
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  padding: ${({ theme }) => `${theme.space.xxs} ${theme.space.lg}`};
  text-align: center;
`
export const IconBadgeContainer = styled.div`
  display: inline-flex;
`
export const HeaderIconsGroup = styled.div`
  display: inline-flex;
  vertical-align: middle;
  min-height: ${({ theme }) => theme.fontSize.xxl};
  margin: ${({ theme }) => `${theme.space.xxxs} 0`};
  div:not(:first-child) {
    margin-left: ${({ theme }) => theme.space.xxs};
  }
`
export const CollapseTitleGroup = styled.div`
  display: inline-flex;
  margin-right: ${({ theme }) => theme.space.sm};
  align-items: center;
  vertical-align: middle;
  flex-wrap: wrap;
  row-gap: ${({ theme }) => theme.space.xs};
`
export const IconBadge = styled.span`
  background-color: ${({ theme }) => theme.palette.blue70};
  vertical-align: middle;
  height: ${({ theme }) => theme.fontSize.xxl};
  width: ${({ theme }) => theme.fontSize.xxl};
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  &:first-child > span {
    margin: auto;
    font-size: ${({ theme }) => theme.fontSize.md};
  }
`
export const LegendContainer = styled.div`
  & > div:first-child {
    margin-right: ${({ theme }) => theme.space.xl};
  }
  ${IconBadge} {
    margin-right: ${({ theme }) => theme.space.xs};
    color: ${({ theme }) => theme.palette.blue100};
    background-color: ${({ theme }) => theme.palette.blue20};
  }
  div {
    font-size: ${({ theme }) => theme.fontSize.xxs};
    display: inline-flex;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.space.xs};
  }
`
export const Content = styled.div`
  .inactive {
    .inprogress {
      background-color: ${({ theme }) => theme.colors.textLinkVisited};
      color: ${({ theme }) => theme.colors.brandPrimaryContrast};
    }
    ${LangBadge} {
      background-color: ${({ theme }) => theme.colors.brandSupporting03};
      color: ${({ theme }) => theme.colors.brandPrimaryContrast};
    }
    ${IconBadge} {
      background-color: ${({ theme }) => theme.palette.blueGray10};
      color: ${({ theme }) => theme.palette.blueGray60};
    }
  }
  ${Title} {
    padding: ${({ theme }) => `${theme.space.xs} ${theme.space.md}`};
  }
  ${PanelBox} {
    margin-bottom: ${({ theme }) => theme.space.md};
    padding: 1px;
  }
  .no-padding {
    padding: 0;
  }
`
export const StyledVideo = styled.video`
  outline: none;
  max-width: 100%;
  height: auto;
`
export const SubHeaderOutline = styled(Row)`
  border: ${({ theme }) => `1px solid ${theme.colors.textLinkVisited}`};
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};
  margin-bottom: ${({ theme }) => theme.space.md};
  color: ${({ theme }) => theme.colors.text03};
  border-radius: 3px;
  .no-padding {
    padding: 0;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: end;
  }
`
export const ContentOutline = styled(Row)`
  border: ${({ theme }) => `1px solid ${theme.colors.brandPrimary}`};
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};
  color: ${({ theme }) => theme.colors.text03};
  border-radius: 3px;
  .no-padding {
    padding: 0;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: end;
  }
`
export const ProgramContent = styled(Row)`
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};
  margin-bottom: ${({ theme }) => theme.space.md};
  color: ${({ theme }) => theme.colors.text03};
  border-radius: 3px;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: end;
  }
`
export const ChapterContent = styled(Row)`
  background: ${({ theme }) => theme.colors.brandPrimaryContrast};
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};
  margin-bottom: ${({ theme }) => theme.space.md};
  color: ${({ theme }) => theme.colors.text03};
  border-radius: 3px;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: end;
  }
`
export const TileLoaderContainer = styled.div`
  position: relative;
  .tile-container {
    position: relative;
    border: 1px solid ${({ theme }) => theme.colors.ui04};
    border-top: 12px solid ${({ theme }) => theme.colors.ui04};
    border-radius: ${({ theme }) => theme.radius.lg};
    background-color: ${({ theme }) => theme.colors.brandPrimaryContrast};
    color: ${({ theme }) => theme.colors.brandSecondaryContrast};
    .content {
      width: 229px;
      height: 274px;
      padding-left: ${({ theme }) => theme.space.sm};
      padding-right: ${({ theme }) => theme.space.sm};
      .icon {
        position: relative;
        margin-bottom: ${({ theme }) => theme.space.sm};
        height: 35px;
      }
      .text {
        font-size: ${({ theme }) => theme.fontSize.sm};
        font-weight: ${({ theme }) => theme.fontWeight.bold};
        line-height: ${({ theme }) => theme.lineHeight.md};
        height: 100px;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: 0.63px;
      }
    }
    .button {
      background-color: ${({ theme }) => theme.colors.ui04};
      color: ${({ theme }) => theme.colors.brandSecondaryContrast};
      outline: none;
      padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};
    }
  }
`
export const Back = styled(Button)`
  padding: ${({ theme }) => `0 ${theme.space.xs} 0 ${theme.space.xxs}`};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  border: 0;
  margin-bottom: ${({ theme }) => theme.space.md};
  svg {
    color: ${({ theme }) => theme.colors.brandPrimaryContrast};
    transform: rotate(180deg);
    margin-top: ${({ theme }) => theme.space.xxxs};
  }
  &:focus {
    outline: 0;
  }
`
export const Body = styled(Grid)`
  padding: 0;
`
export const SelectWrapper = styled.div`
  padding: ${({ theme }) => `${theme.space.lg} 0 0 ${theme.space.lg}`};
  width: ${({ theme }) => theme.layout.xxl};
  & > div {
    width: 100%;
  }
`
export const SelectorContainer = styled(Col)`
  padding: 0;
  .ant-select {
    width: 100%;
  }
`
export const PageHeaderCtr = styled.div`
  display: flex;
  flex-wrap: wrap;
`
export const NxtLvlCtr = styled.div`
  margin-left: auto;
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin: auto;
    width: 100%;
    margin-bottom: ${({ theme }) => theme.space.md};
    ${Wrapper} {
      display: flex;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: auto;
    width: 100%;
    margin-bottom: ${({ theme }) => theme.space.md};
    ${Wrapper} {
      display: flex;
      flex-direction: column;
      ${NextLvlCol}, ${ButtonCol} {
        margin: auto;
      }
      ${ButtonCol} {
        padding-left: 0;
        margin-top: ${({ theme }) => theme.space.xs};
      }
    }
  }
`
export const MaintenanceBannerContainer = styled.div`
  background-color: #f4f8ff;
  display: flex;
  justify-content: center;
  padding-top: ${({ theme }) => theme.space.xl};
  padding-bottom: ${({ theme }) => theme.space.lg};
  margin-top: ${({ theme }) => theme.space.lg};
  margin-left: ${({ theme }) => theme.space.lg};
  margin-right: ${({ theme }) => theme.space.lg};
`
export const LpCtCardOverride = styled.div<{ status: string }>`
  ${({ status }) =>
    status === 'Unlocked' &&
    css`
      button {
        background-color: #45b55a;
      }
    `}
`
export const SelectorWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${({ theme }) => `
    column-gap: ${theme.space.md};
    row-gap: ${theme.space.sm};
    margin-top: ${theme.space.sm};
    label {
      font-size: ${theme.fontSize.xxxs};
    }
  `}
`
export const TabItemWrapper = styled.div`
  cursor: pointer;
  margin-right: 50px;
`
export const TabWrapper = styled.div`
  width: 100%;
`
export const NonSelectedSkillContent = styled.div`
  ${PanelBox} {
    filter: grayscale(100%);
  }
`
export const ButtonWrapper = styled.div`
  text-align: right;
`
export const ModalWrapper = styled.div`
  text-align: center;
`
export const SpinnerWrapper = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${({ theme }) => theme.space.xxl};
  margin-bottom: ${({ theme }) => theme.space.xxl};
`